<template>
    <div v-if="record">
        <div
            v-if="
                record.summary.givenDate && record.summary.givenDate.length > 0
            "
        >
            <strong>Given:</strong>
            {{ _setDateTimeDisplay(record.summary.givenDate) }}
        </div>
        <template v-if="Object.keys(record.return_item).length > 0">
            <div v-if="record.summary.quantity > 0">
                <strong>Quantity:</strong> {{ getCalcSummaryQuantity(record) }}
            </div>
            <template v-if="record.invoice_item.isfullreturn == 0">
                <div>
                    <strong>Returned:</strong>
                    {{ record.return_item.quantity }} {{ oumLabel }}
                </div>
                <record-lot :record="record"></record-lot>
            </template>
        </template>
        <template v-else>
            <div v-if="record.summary.quantity > 0">
                <strong>Quantity:</strong> {{ record.summary.quantity }}
                {{ oumLabel }}
            </div>
            <record-lot :record="record"></record-lot>
        </template>

        <div v-if="record.refill > 0 && itemTypeId !== GROOMING_ID">
            <strong>Refills:</strong>
            {{
                record.summary.refills +
                " (" +
                record.summary.remainingRefill +
                " remaining)"
            }}
        </div>
        <div v-if="record.summary.tag">
            <strong>Tag:</strong> {{ record.summary.tag }}
        </div>
        <div v-if="record.summary.microchip">
            <strong>Chip:</strong> {{ record.summary.microchip }}
        </div>
        <div v-if="record.summary.route">
            <strong>Route:</strong> {{ record.summary.route }}
        </div>
        <div v-if="record.summary.location">
            <strong>Location:</strong> {{ record.summary.location }}
        </div>
        <div v-if="record.summary.notes">
            <strong>Notes:</strong> <span v-html="record.summary.notes"></span>
        </div>
        <div v-if="record.instruction && record.instruction.length > 0">
            <strong>Instructions:</strong> {{ record.instruction }}
        </div>

        <div v-if="record.diagnoses.length > 0">
            <strong>Open Diagnoses:</strong>
            <template v-if="isEditable">
                <b
                    v-for="(diagnosis, index) in record.diagnoses"
                    :key="diagnosis.id + record.id"
                    @click="$emit('edit-diagnosis', diagnosis)"
                    class="text-primary cursor-pointer"
                >
                    {{ diagnosis.description }}
                    <span v-if="index != record.diagnoses.length - 1">,</span>
                </b>
            </template>
            <template v-else>
                <b
                    v-for="(diagnosis, index) in record.diagnoses"
                    :key="diagnosis.id + record.id"
                >
                    {{ diagnosis.description }}
                    <span v-if="index != record.diagnoses.length - 1">,</span>
                </b>
            </template>
        </div>

        <div v-if="record.summary.attachments.length > 0">
            <strong>Attachments:</strong><br />
            <div v-for="(file, i) in record.summary.attachments" :key="file.id">
                <a v-if="file.isS3" :href="file.filePath" target="_blank">{{
                    file.title
                }}</a>
                <a v-else :href="baseURL + file.filePath" target="_blank">{{
                    file.title
                }}</a>
                <span v-if="i != record.summary.attachments.length - 1">,</span>
            </div>
        </div>
        <div v-if="record.item_dispensing_references.length > 0">
            <div>
                <strong>Status: </strong>

                <b-badge
                    :variant="
                        getStatusVariant(
                            record.item_dispensing_references[0].status_name
                        )
                    "
                    class="mr-1"
                >
                    {{ record.item_dispensing_references[0].status_name }}
                </b-badge>
            </div>

            <span
                v-if="record.item_dispensing_references[0].dispensed"
                class="d-flex"
            >
                <strong>Dispensed: </strong>
                <span class="pl-2">
                    {{ record.item_dispensing_references[0].dispensed }}
                    {{ oumLabel }}
                </span>
            </span>

            <span
                v-if="record.item_dispensing_references[0].returned"
                class="d-flex"
            >
                <strong>Returned: </strong>
                <span class="pl-2">
                    {{ record.item_dispensing_references[0].returned }}
                    {{ oumLabel }}
                </span>
            </span>

            <span
                v-if="record.item_dispensing_references[0].waste"
                class="d-flex"
            >
                <strong>Waste: </strong>
                <span class="pl-2">
                    {{ record.item_dispensing_references[0].waste }}
                    {{ oumLabel }}
                </span>
            </span>
        </div>
    </div>
</template>
<script>
import RecordRowMixin from "@/mixins/record-row";

export default {
    mixins: [RecordRowMixin],
    components: {
        RecordLot: () => import("@/components/medical-records/record-lot")
    },
    props: {
        record: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            GROOMING_ID: 20,
            baseURL: process.env.APPS
        };
    },
    computed: {
        oumLabel() {
            return this.record.item_uom ? this.record.item_uom.value : "";
        },
        itemTypeId() {
            return this.record && this.record.item.item_type
                ? this.record.item.item_type.id
                : 0;
        },
        isEditable() {
            return (
                this.record.business &&
                this.record.business.id === this._setting.business_id
            );
        }
    },
    methods: {
        getCalcSummaryQuantity(object) {
            let quantity =
                parseFloat(object.summary.quantity) -
                parseFloat(object.return_item.quantity);
            return quantity + " " + this.oumLabel;
        }
    }
};
</script>
